import { produce } from 'immer'
import { ActionType, getType } from 'typesafe-actions'

import { emptyNormalizedCoverageData } from '../coverage/coverage.utils'
import { createCrossCoverageAction } from './actions/createCrossCoverage'
import { fetchCrossCoverageByIdAction } from './actions/fetchCrossCoverageById'
import { fetchCrossCoveragesAction } from './actions/fetchCrossCoverages'
import { CrossCoverageState } from './crossCoverage.types'

export const initialState: CrossCoverageState = {
  data: {},
  error: undefined,
}

const actions = {
  createCrossCoverageAction,
  fetchCrossCoverageByIdAction,
  fetchCrossCoveragesAction,
}

type CrossCoverageActionsTypes = ActionType<typeof actions>

export const crossCoverageReducer = (
  state = initialState,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  action: CrossCoverageActionsTypes,
): CrossCoverageState =>
  produce(state, (draft: CrossCoverageState) => {
    switch (action.type) {
      case getType(fetchCrossCoveragesAction.success): {
        const normalized =
          action?.payload?.normalized || emptyNormalizedCoverageData
        draft.data = normalized.crossCoverage

        return
      }

      case getType(fetchCrossCoverageByIdAction.success): {
        const normalized =
          action?.payload?.normalized || emptyNormalizedCoverageData
        draft.data = { ...draft.data, ...normalized.crossCoverage }

        return
      }
    }
  })
